import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLandscape = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 36,
	height: 37,
	viewBox: "0 0 36 37",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		opacity: .5,
		clipPath: "url(#clip0_6376_1418)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M31.5 32V5H4.5V32H31.5ZM12.75 20.75L16.5 25.265L21.75 18.5L28.5 27.5H7.5L12.75 20.75Z",
			fill: "white"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_6376_1418",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 36,
			height: 36,
			fill: "white",
			transform: "translate(0 0.5)"
		})
	}) })]
});
export default SvgLandscape;
